export default {
  routes: [
    {
      name: 'medexams',
      path: '/directory/medexam',
      component: () => import('./views/TheMedExamPages.vue'),

    },

    {
      name: 'medexam',
      path: '/directory/medexam/:uuid',
      component: () => import('./views/TheMedExamPage.vue'),
    },

    {
      name: 'employees-wo-medexams',
      path: '/directory/employees-wo-medexams',
      component: () => import('./views/employeesWoMedExams/TheEmployeesWoMedExamsPage.vue'),
    }
  ]
}
